import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ActivityCategoryDashboardPage" */
	'pages/sales/ActivityCategory/ActivityCategoryDashboardPage'));

export default [{ component, exact: true, path: '/activity_categories/:activityCategoryId' }];